import React from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

type Props = {
  label: string;
  options: string[];
  required?: boolean;
  value?: string;
  fullWidth?: boolean;
};

/**
 * ガイド画面で表示用のモックセレクト（操作不能）
 */
const GuideMockSelect: React.FC<Props> = ({
  label,
  options,
  required = false,
  value,
  fullWidth = true,
}) => {
  return (
    <FormControl
      size="small"
      fullWidth={fullWidth}
      required={required}
      sx={{ pointerEvents: 'none' }}
    >
      <InputLabel>{label}</InputLabel>
      <Select label={label} value={value || ''} sx={{ borderRadius: 2 }}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GuideMockSelect;
